import { render, staticRenderFns } from "./colors.configurator.vue?vue&type=template&id=11dfe7c3&"
import script from "./colors.configurator.vue?vue&type=script&lang=ts&"
export * from "./colors.configurator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports